module.exports = __webpack_public_path__ + "static/media/lgout.048b0f3e.png";